import { gql } from '@apollo/client';
import { IContentfulImage } from '../../interfaces/contentful-image.interface';
import { TTenantTypes } from './meetingPlacePageTenantList';
import { ILibraryEventType } from './libraryEventType';
import { EntryFragment } from './entry';
import { AssetFragment } from './asset';
import { SvgFragment } from './svg';
import {
  MeetingPlacePageTenantFoodBevItemMinifiedFragment,
  MeetingPlacePageTenantFoodBevItemMinifiedLogoFragment,
} from './meetingPlacePageTenantFoodBevItem';
import {
  MeetingPlacePageTenantEntertainmentItemMinifiedFragment,
  MeetingPlacePageTenantEntertainmentItemMinifiedLogoFragment,
} from './meetingPlacePageTenantEntertainmentItem';
import {
  MeetingPlacePageTenantShopItemMinifiedFragment,
  MeetingPlacePageTenantShopItemMinifiedLogoFragment,
} from './meetingPlacePageTenantShopItem';

export interface IMeetingPlacePageEventItem {
  __typename: string;
  sys: {
    id: string;
  };
  name: string;
  caption: string;
  slug: string;
  updatedAt?: string | Date;
  startDate: any;
  tags: string[];
  endDate: any;
  hideInListFrom: string;
  mediaField: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText: string;
  };
  body: any;
  eventTypesCollection: {
    items: ILibraryEventType[];
  };
  tenant: TTenantTypes;
  floorPlanId: string;
  customizedSlug: string;
  node_locale: string;
  seoDescription: { seoDescription: string };
  priority: number;
  slots?: any;
}

export const MeetingPlacePageEventItemFragment = gql`
  ${MeetingPlacePageTenantShopItemMinifiedLogoFragment}
  ${MeetingPlacePageTenantEntertainmentItemMinifiedLogoFragment}
  ${MeetingPlacePageTenantFoodBevItemMinifiedLogoFragment}
  fragment MeetingPlacePageEventItem on MeetingPlacePageEvent {
    __typename
    sys {
      id
    }
    name
    caption
    slug
    tags
    startDate
    endDate
    hideInListFrom
    mediaField {
      jsonBynderAsset
      altText
    }
    body {
      json
    }
    eventTypesCollection {
      items {
        ... on LibraryEventType {
          sys {
            id
          }
          name
        }
      }
    }
    tenant {
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...MeetingPlacePageTenantShopItemMinifiedLogo
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...MeetingPlacePageTenantEntertainmentItemMinifiedLogo
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...MeetingPlacePageTenantFoodBevItemMinifiedLogo
        }
      }
    }
    floorPlanId
    seoDescription
    priority
  }
`;

export const MeetingPlacePageEventListItemFragment = gql`
  ${MeetingPlacePageTenantShopItemMinifiedLogoFragment}
  ${MeetingPlacePageTenantEntertainmentItemMinifiedLogoFragment}
  ${MeetingPlacePageTenantFoodBevItemMinifiedLogoFragment}
  fragment MeetingPlacePageEventListItem on MeetingPlacePageEvent {
    __typename
    sys {
      id
    }
    name
    slug
    startDate
    endDate
    hideInListFrom
    mediaField {
      jsonBynderAsset
      altText
    }
    eventTypesCollection {
      items {
        ... on LibraryEventType {
          sys {
            id
          }
          name
        }
      }
    }
    tenant {
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...MeetingPlacePageTenantShopItemMinifiedLogo
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...MeetingPlacePageTenantEntertainmentItemMinifiedLogo
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...MeetingPlacePageTenantFoodBevItemMinifiedLogo
        }
      }
    }
    priority
  }
`;
